// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var CouponEditController = function ($scope, $rootScope, $routeParams, $location, Coupon, CouponByPlanGroup,
    ProductInfo, FileUploader, $filter, gettextCatalog, gettext, CouponSettings, PUtill, DatepickerUtils) {

    $scope.uploader = { queue: [] };
    $scope.allowedUploadSize = 15*1024*1024;
    $scope.errorMessage = '';

    // PAGING
    $scope.paging = {
        pageNumber: 1,
        pageSize: 10,
        totalCount: 0,
        itemsPerPage: 20,
        itemsPerCol: 5,
        maxSize: 10,
        cols: 4
    };

    $scope.couponSettings = CouponSettings.get();

    $scope.$watch("paging.pageNumber", function () {
        prepareCodeToView();
    });
    function pagingReset() {
        $scope.paging.pageNumber = 1;
    }

    // DATA HANDLERS
    $scope.countUsedCodes = 0;
    $scope.couponCodes = [];//contains
    $scope.couponCodesKeys = {};// contains uniq codes
    $scope.previewCodes = [];
    $scope.viewList = [];
    $scope.search = '';

    function updateCodes() {
        if ($routeParams.couponId) {
            $scope.coupon = Coupon.get({ couponId: $routeParams.couponId }, function () {
                updateData();
            });
        }
    }

    $scope.updateFilter = function () {
        pagingReset();
        updateData();
    };

    function updateData() {
        parseData();
        filterData();
        prepareCodeToView();
    }

    function parseData() {
        var couponCodes = $scope.couponCodes = [];
        var couponCodesKeys = $scope.couponCodesKeys = {};
        var codes = $scope.coupon.Codes;
        var uniqCodes = [];
        angular.forEach(codes, function (value, key) {
            if (!(value in couponCodesKeys)) {
                couponCodesKeys[value] = 1;
                uniqCodes.push(value);
                this.push({ 'i': key, 'value': value });
            }
        }, couponCodes);

        $scope.coupon.Codes = uniqCodes;

        getCountUsedCodes();
    }

    // calculate used codes
    function getCountUsedCodes() {
        var usedCodes = $scope.coupon.UsedCodes;
        var countCodes = 0;
        for (var i in usedCodes) {
            if (usedCodes.hasOwnProperty(i)) {
                countCodes++;
            }
        }
        $scope.countUsedCodes = countCodes;
    }

    function filterData() {
        if ($scope.search.length > 0) {
            $scope.previewCodes = $filter('filter')($scope.couponCodes, { 'value': $scope.search });
        } else {
            $scope.previewCodes = $scope.couponCodes;
        }
        $scope.paging.totalCount = $scope.previewCodes.length;
    }

    function addCodes(codes) {
        $scope.coupon.Codes = $scope.coupon.Codes.concat(codes);
        updateData();
    }

    function prepareCodeToView() {
        var paging = $scope.paging;
        $scope.viewList = [];
        var count = paging.cols * paging.itemsPerCol;
        var start = (paging.pageNumber - 1) * count;
        var codes = $scope.previewCodes.slice(start, start + count);
        var coupon = $scope.coupon;
        if (!coupon.UsedCodes) {
            coupon.UsedCodes = {};
        }
        angular.forEach(codes, function (it) {
            it.t = it.v = it.value;

            if (it.v.length > 23) {
                it.v = it.v.substring(0, 21) + '..';
            }

            if (it.value in coupon.UsedCodes) {
                it.used = true;
                it.t += '(used)';
            }
        });

        for (var i = 0; i < codes.length; i += paging.itemsPerCol) {
            $scope.viewList.push(codes.slice(i, i + paging.itemsPerCol));
        }
    }

    if ($routeParams.couponId) {
        $scope.coupon = Coupon.get({ couponId: $routeParams.couponId }, function () {
            updateData();
        });
    } else {
        $scope.coupon = new CouponByPlanGroup();
        $scope.coupon.PlanGroupId = $routeParams.planGroupId;
        $scope.coupon.Codes = [];
    }

    $scope.productInfo = ProductInfo.get(function () { }, false);

    $scope.addCode = function () {
        if ($scope.newCode in $scope.couponCodesKeys) {
            $scope.notify("error", gettextCatalog.getString(gettext('This code is already exists!')));
        } else {
            $scope.coupon.Codes.push($scope.newCode);
            $scope.newCode = "";
            updateData();
        }
    };

    $scope.deleteCode = function (index) {
        $scope.coupon.Codes.remove(index);
        updateData();
    };

    $scope.deleteSelectedCodes = function () {
        if ($scope.coupon.Codes.length === $scope.previewCodes.length) {
            $scope.coupon.Codes = [];
        } else {
            var len = $scope.previewCodes.length;
            for (var i = 0; i < len; i++) {
                $scope.coupon.Codes[$scope.previewCodes[i].i] = null;
            }
            var res = [];
            angular.forEach($scope.coupon.Codes, function (value) {
                if (value !== null) {
                    res.push(value);
                }
            });
            $scope.coupon.Codes = res;
        }
        updateData();
    };

    function finish() {
        $location.path("/products");
    }

    $scope.cancel = finish;

    $scope.save = function () {
        if (!$rootScope.isValid($scope.form)) return;

        if ($routeParams.couponId)
            $scope.coupon.$update({ couponId: $scope.coupon.Id }, finish);
        else
            $scope.coupon.$save({ planGroupId: $routeParams.planGroupId }, finish);
    };

    $scope.getActionPath = function () {
        return 'codesupload/upload';
    };

    //// CALLBACKS
    $scope.onCompleteItem = function (fileItem, response) {
        if (fileItem.isCancel !== true) {
            if (response && response.Status === 'success') {
                if (response.Codes && response.Codes.length > 0)
                    addCodes(response.Codes);
                else
                    updateCodes();

                $scope.notify("success", response.Codes.length + gettextCatalog.getString(gettext(" code(s) uploaded successfully.")));
            }
            else {
                fileItem.isError = true;
                fileItem.isSuccess = false;
                $scope.notify("error", gettextCatalog.getString(gettext(response.Message)));
            }
        }
    };

    $scope.$watch('errorMessage', function (newValue) {
        if (newValue) {
            $rootScope.showErrorBox(newValue);
        }
    });

    $scope.$watch('coupon.ValidFrom', function (newValue, oldValue) {
        if (!newValue) return;
        if (PUtill.areDatesEqual(newValue, oldValue)) return;

        if ($scope.coupon.ValidUntil && $scope.coupon.ValidUntil <= $scope.coupon.ValidFrom) {
            let newFrom = moment($scope.coupon.ValidUntil).subtract(1, 'days').toDate();
            DatepickerUtils.markAsAlreadyInBrowserTimezone(newFrom);
            $scope.coupon.ValidFrom = newFrom;
        }
    });

    let validUntilIncremented = false;
    $scope.$watch('coupon.ValidUntil', function (newValue, oldValue) {
        if (validUntilIncremented) {
            validUntilIncremented = false;
            return;
        }

        if (!newValue || oldValue === undefined) return;
        if (PUtill.areDatesEqual(newValue, oldValue)) return;

        let newMoment = moment($scope.coupon.ValidUntil).add(1, 'days');
        if ($scope.coupon.ValidFrom && $scope.coupon.ValidFrom > $scope.coupon.ValidUntil)
            newMoment = moment($scope.coupon.ValidFrom).add(1, 'days');

        let newUntil = newMoment.toDate();
        DatepickerUtils.markAsAlreadyInBrowserTimezone(newUntil);
        $scope.coupon.ValidUntil = newUntil;
        validUntilIncremented = true;
    });

    $scope.getDuration = function () {
        if ($scope.coupon && $scope.coupon.ValidFrom && $scope.coupon.ValidUntil)
            return Math.round(Math.abs(($scope.coupon.ValidFrom.getTime() - $scope.coupon.ValidUntil.getTime()) / 86400000));
        else
            return null;
    };
};
CouponEditController.$inject = ['$scope', '$rootScope', '$routeParams', '$location', 'Coupon', 'CouponByPlanGroup',
    'ProductInfo', 'FileUploader', '$filter', 'gettextCatalog', 'gettext', 'CouponSettings', 'PUtill', 'DatepickerUtils'];
